/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import { Handler } from './../handler';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { OAuthService } from './../oauth/oauth.service';
import { environment } from './../../../../environments/environment';
import { HttpModule, Http, Headers, Response, RequestOptions } from '@angular/http';


@Injectable()
export class TopBrandsService {
    private baseUrl;
    private endpoint = 'home/top-brands';

    constructor(
        private http: Http,
        private oauthService: OAuthService,
        private handler: Handler,
    ) {
        this.baseUrl = environment.apiEndpoint;
    }

    public getTopBrands(): Observable<any> {
        return this.oauthService.getAccessToken()
            .flatMap((data) => (this.aux(data)))
            .catch(this.handler.render);
    }

    public aux(accessToken: String): Observable<any> {
        let objHeaders = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.rest.v1+json',
            'Authorization': `Bearer ${accessToken}`
        });
        let options = new RequestOptions({
            headers: objHeaders
        });
        return this.http
            .get(this.baseUrl + this.endpoint, options)
            .map((response: Response) => (response.json().message));
    }
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/services/Home/top-brands.service.ts